import React from 'react'
import { cn } from '~/lib/utils'

const ResourceIcon = ({ completed, Icon, className }) => {
  return (
    <Icon
      className={cn(
        'ml-2',
        completed ? 'stroke-[#2F2F2F]' : 'stroke-white',
        className,
      )}
    />
  )
}

export default ResourceIcon
